import React, { useEffect, useState } from 'react';

import { TouchableOpacity, Text, View } from 'react-native';

import EditScreenInfo from '../components/EditScreenInfo';
import {
    LineChart,
    BarChart,
    PieChart,
    ProgressChart,
    ContributionGraph,
    StackedBarChart
} from "react-native-chart-kit";
import { log, logerror } from './Common';
import moment from 'moment';

export default class SubStatsMinutescounts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datas: [],
            datasx: [],
            type: this.props.type,
            limmins: this.props.limmins,
            title: this.props.title,
            w: parseInt(this.props.w),
            h: parseInt(this.props.h),
            currentTime: "",
        }
        log('handleDatax w  ' + this.props.w);

    }
    // This method will execute everytime a state or props change.
    componentDidUpdate(prevProps) {
    }
    componentDidMount(props) {
        this.getDatas();
        const interval = setInterval(() => {
            log('handleDatay xxx ');
            this.getDatas();
        }, 5000);
        return () => clearInterval(interval);


    }
    handleData(datax) {
        var resultx = [];
        var resultxx = [];
        var limmins = 2 * 60 * 60;
        if (this.state.limmins != "0") {
            log('handleDatay limhour  ' + this.state.limmins);
            limmins = parseInt(this.state.limmins);
        }
        //  log('handleData ' + JSON.stringify(datax));
        log('handleDatay parse ' + JSON.stringify(datax[0]));
        log('handleDatay lenght ' + Object.keys(datax).length);
        var oldx = 0;
        for (var i = 0; i < limmins; i++) {
            resultx.push(0);
        }
        for (var i = limmins; i > 0; i = i - (limmins / 10)) {
            resultxx.push(i);
        }
        log('handleDatay 1 ' + JSON.stringify(resultx));
        for (var i = 0; i < datax.length; i++) {
            var obj = datax[i];
            if (parseInt(obj.ref) < limmins) {
                log('handleDatay for obj ' + JSON.stringify(obj));
                //   log('handleDatax for count ' + JSON.stringify(obj.count));
                //   log('handleDatax for ref ' + JSON.stringify(obj.ref));
                //  log('handleDatax for 1 ' + JSON.stringify(obj.count) + " " + parseInt(obj.ref));
                //   log('handleDatax for ok ' + JSON.stringify(obj.count) + " " + parseInt(obj.ref));
                resultx[limmins - parseInt(obj.ref) - 1] = obj.count;
            }
        }
        var oldx = 0;
        log('handleDatay 2 ' + JSON.stringify(resultx));
        if (this.state.type == "2") {
            for (var i = 0; i < limmins; i++) {
                oldx = oldx + resultx[i];
                resultx[i] = oldx;
            }
        }

        log('handleDatay 3 ' + JSON.stringify(resultx));
        this.state.datas = resultx;
        this.state.datasx = resultxx;
        log('handleDatay 3 ' + limmins);

        var formattedDate = moment().format("HH:mm:ss"); // "Monday, August 12th 2019, 5:52:00 pm"
        this.state.currentTime = formattedDate;
    }

    getDatas = () => {
        fetch(global.docker + 'monitor/countminutesapicalls', {
            method: 'get',
            headers: {
                'Accept': 'application/json, text/plain, */*',  // It can be used to overcome cors errors
                'Content-Type': 'application/json'
            }
        }
        )
            .then((response) => response.json())
            .then((json) => this.handleData(json))
            .catch((error) => logerror("getDatas", error))
            .finally(() => this.setState({ loadingphotosgroup: false })
            );
    }



    render() {
        return (
            <TouchableOpacity
                onPress={() => this.getDatas()}   >
                <View >
                    <Text >
                    {this.state.title} {this.state.currentTime} 
                    </Text>

                    <LineChart
                        data={{
                            labels: this.state.datasx,
                            datasets: [
                                {
                                    data: this.state.datas
                                }
                            ]
                        }}
                        width={this.state.w} // from react-native
                        height={this.state.h} // from react-native
                        yAxisLabel=""
                        yAxisSuffix=""
                        yAxisInterval={30} // optional, defaults to 1
                        chartConfig={{
                            backgroundColor: "#000044",
                            backgroundGradientFrom: "#000066",
                            backgroundGradientTo: "#000022",
                            decimalPlaces: 0, // optional, defaults to 2dp
                            color: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
                            labelColor: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
                            style: {
                                borderRadius: 16
                            },
                            propsForDots: {
                                r: "1",
                                strokeWidth: "0",
                                stroke: "#ffa726"
                            }
                        }}
                        style={{
                            marginVertical: 8,
                            borderRadius: 8
                        }}
                    />
                </View>
            </TouchableOpacity>

        )
    }


}